import { jsx as _jsx } from "react/jsx-runtime";
import './config/i18n';
import AppRouter from './app-router';
export function TrackingApp() {
  return /*#__PURE__*/_jsx(AppRouter, {});
}